



























































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

interface MenuDataSet {
  kbn: string,
  view_name: string,
  visibility: string,
  name: string,
  link: string,
}

@Component({})

export default class SchoolDesignPreviewComponent extends Vue {
  pageBodyPreview = (window as any).page_preview || ''
  previewMode: string = 'realtime-view'
  logo: string = (<HTMLInputElement>document.querySelector('#logo')) ? (<HTMLInputElement>document.querySelector('#logo')).dataset.url : ''
  pageLogo: string = (<HTMLInputElement>document.querySelector('#page_logo')) ? (<HTMLInputElement>document.querySelector('#page_logo')).dataset.url : ''
  navbarBgColor: string = (<HTMLInputElement>document.querySelector('#school_design_general_page_nav_color')).value
  navTextColor: string = (<HTMLInputElement>document.querySelector('#school_design_general_page_nav_text_color')).value
  pageTitle: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_title')).value
  pageDescription: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_description')).value
  pageTextColor: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_text_color')).value
  featureTitle: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_title')).value
  feature1Title: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_1_title')).value
  feature1Description: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_1_description')).value
  feature1ImageUrl: string = (<HTMLInputElement>document.querySelector('#feature_1_image')) ? (<HTMLInputElement>document.querySelector('#feature_1_image')).dataset.url : ''
  feature2Title: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_2_title')).value
  feature2Description: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_2_description')).value
  feature2ImageUrl: string = (<HTMLInputElement>document.querySelector('#feature_2_image')) ? (<HTMLInputElement>document.querySelector('#feature_2_image')).dataset.url : ''
  feature3Title: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_3_title')).value
  feature3Description: string = (<HTMLInputElement>document.querySelector('#school_design_main_page_feature_3_description')).value
  feature3ImageUrl: string = (<HTMLInputElement>document.querySelector('#feature_3_image')) ? (<HTMLInputElement>document.querySelector('#feature_3_image')).dataset.url : ''

  menuData: MenuDataSet[] = []

  public mounted() {
    document.querySelector('input[name="school_design[logo]"]').addEventListener('change', this.changeImage.bind(null, 'logo'))
    document.querySelector('#school_design_general_page_nav_color').addEventListener('change', this.changeValue.bind(null, 'navbarBgColor'))
    document.querySelector('#school_design_general_page_nav_text_color').addEventListener('change', this.changeValue.bind(null, 'navTextColor'))
    document.querySelector('#school_design_main_page_text_color').addEventListener('change', this.changeValue.bind(null, 'pageTextColor'))
    document.querySelector('#school_design_main_page_page_logo').addEventListener('change', this.changeImage.bind(null, 'pageLogo'))

    document.querySelector('#school_design_main_page_title').addEventListener('keyup', this.changeValue.bind(null, 'pageTitle'))
    document.querySelector('#school_design_main_page_description').addEventListener('keyup', this.changeValue.bind(null, 'pageDescription'))

    document.querySelector('#school_design_main_page_feature_title').addEventListener('keyup', this.changeValue.bind(null, 'featureTitle'))
    document.querySelector('#school_design_main_page_feature_1_title').addEventListener('keyup', this.changeValue.bind(null, 'feature1Title'))
    document.querySelector('#school_design_main_page_feature_1_description').addEventListener('keyup', this.changeValue.bind(null, 'feature1Description'))
    document.querySelector('#school_design_main_page_feature_1_image').addEventListener('change', this.changeImage.bind(null, 'feature1ImageUrl'))
    document.querySelector('#school_design_main_page_feature_2_title').addEventListener('keyup', this.changeValue.bind(null, 'feature2Title'))
    document.querySelector('#school_design_main_page_feature_2_description').addEventListener('keyup', this.changeValue.bind(null, 'feature2Description'))
    document.querySelector('#school_design_main_page_feature_2_image').addEventListener('change', this.changeImage.bind(null, 'feature2ImageUrl'))
    document.querySelector('#school_design_main_page_feature_3_title').addEventListener('keyup', this.changeValue.bind(null, 'feature3Title'))
    document.querySelector('#school_design_main_page_feature_3_description').addEventListener('keyup', this.changeValue.bind(null, 'feature3Description'))
    document.querySelector('#school_design_main_page_feature_3_image').addEventListener('change', this.changeImage.bind(null, 'feature3ImageUrl'))
  
    this.updateMenuData()
  }

  get visibilitymMenuData(){
    return this.menuData.filter(item => item.visibility == 'true')
  }
  // Loop to get new data from rails js
  updateMenuData(){
    this.menuData = (window as any).menu_data || []
    setTimeout(() => {
      this.updateMenuData() 
    }, 300);
  }

  @Watch('previewMode')
  watchPreviewMode(){
    if (this.previewMode === 'realtime-view') {
      this.pageBodyPreview = (window as any).page_preview
    }
  }

  changeValue(type, event) {
    if (type === 'navbarBgColor') this.navbarBgColor = event.target.value
    if (type === 'navTextColor') this.navTextColor = event.target.value
    if (type === 'pageTextColor') this.pageTextColor = event.target.value

    if (type === 'pageTitle') this.pageTitle = event.target.value
    if (type === 'pageDescription') this.pageDescription = event.target.value
    if (type === 'featureTitle') this.featureTitle = event.target.value
    if (type === 'feature1Title') this.feature1Title = event.target.value
    if (type === 'feature1Description') this.feature1Description = event.target.value
    if (type === 'feature2Title') this.feature2Title = event.target.value
    if (type === 'feature2Description') this.feature2Description = event.target.value
    if (type === 'feature3Title') this.feature3Title = event.target.value
    if (type === 'feature3Description') this.feature3Description = event.target.value
  }

  changeImage(type, event) {
    if (!event.target.files || !event.target.files[0]) {
      return
    }
    const reader = new FileReader()
    reader.readAsDataURL(event.target.files[0])
    reader.onload = (e) => {
      if (type === 'feature1ImageUrl') this.feature1ImageUrl = e.target.result as string
      if (type === 'feature2ImageUrl') this.feature2ImageUrl = e.target.result as string
      if (type === 'feature3ImageUrl') this.feature3ImageUrl = e.target.result as string
      if (type === 'pageLogo') this.pageLogo = e.target.result as string
      if (type === 'logo') this.logo = e.target.result as string
    }
  }
}
